import { render, staticRenderFns } from "./WalletDelegation.vue?vue&type=template&id=48efc2e8&"
import script from "./WalletDelegation.vue?vue&type=script&lang=js&"
export * from "./WalletDelegation.vue?vue&type=script&lang=js&"
import style0 from "./WalletDelegation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports